import { HttpClient } from "@angular/common/http";
import { DataService } from "../../core/services/data.service";
import { LaboratoryExaminationCertificateDto } from "../models/laboratory/laboratory-examination-certificate.dto";
import { NotificationService } from "../../core/services/notification.service";
import { Injectable } from "@angular/core";
import { ActionDataResult } from "../models/core/ActionDataResult";
import { Observable } from "rxjs";

@Injectable()
export class LaboratoryExaminationCertificatesService extends 
    DataService<LaboratoryExaminationCertificateDto, LaboratoryExaminationCertificateDto>
{
    constructor(http: HttpClient, notificationService: NotificationService) {
        super(http, notificationService);
        this.controllerName = 'laboratory-examination-certificates';
    }

    checkExistCertificates(requestId: number): Observable<boolean> {
        return this.getQuery<boolean>(`${this.baseUrl()}/check-exist/${requestId}`);
    }

    getCertificateRemarkDescription(requestId: number): Observable<string> {
        return this.getQuery<string>(`${this.baseUrl()}/remark-description/${requestId}`);
    }
}